import Vue from 'vue'
import VueI18n from 'vue-i18n'
import es from './locales/es.js'
import pt from './locales/pt.js'
import vuetify_es from 'vuetify/es5/locale/es'
import vuetify_pt from 'vuetify/es5/locale/pt'

Vue.use(VueI18n)

const DEFAULT_LOCALE = 'es-ES'
const STORAGE_KEY = 'minerva-locale'

const SUPPORTED_LOCALES = {
  'es-ES': { messages: es, vuetify: vuetify_es },
  'pt-PT': { messages: pt, vuetify: vuetify_pt },
}

const getSavedLocale = () => {
  const saved = localStorage.getItem(STORAGE_KEY)
  return saved && SUPPORTED_LOCALES[saved] ? saved : DEFAULT_LOCALE
}

const buildMessages = () => {
  const messages = {}
  Object.entries(SUPPORTED_LOCALES).forEach(([locale, { messages: msgs, vuetify }]) => {
    messages[locale] = { ...msgs, $vuetify: vuetify }
  })
  return messages
}

const numberFormats = {
  'es-ES': {
    decimal: { maximumFractionDigits: 0, minimumFractionDigits: 0 },
  },
  'pt-PT': {
    decimal: { maximumFractionDigits: 0, minimumFractionDigits: 0 },
  },
}

export const createInternationalization = () => ({
  locale: getSavedLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: buildMessages(),
  numberFormats,
})

const i18n = new VueI18n(createInternationalization())

export const setLocale = locale => {
  if (!SUPPORTED_LOCALES[locale]) return
  i18n.locale = locale
  localStorage.setItem(STORAGE_KEY, locale)
}

export const getCurrentLocale = () => i18n.locale

export const initI18n = async store => {
  const translationsResponse = await store.dispatch('offer/REQUEST_TRANSLATIONS')

  if (translationsResponse.data?.data?.length > 0) {
    const remoteTranslations = {}
    translationsResponse.data.data.forEach(item => {
      remoteTranslations[item.key] = item.valueDefault
    })

    // Apply remote overrides only to the ES locale (backend only has ES)
    i18n.setLocaleMessage(DEFAULT_LOCALE, {
      ...SUPPORTED_LOCALES[DEFAULT_LOCALE].messages,
      $vuetify: SUPPORTED_LOCALES[DEFAULT_LOCALE].vuetify,
      ...remoteTranslations,
    })
  }

  return i18n
}

export default i18n
